export default "__VITE_ASSET__Cfit0BPF__"